/* eslint-disable @typescript-eslint/no-explicit-any */
export interface WorkspaceUserFeatures<T = boolean> {
  loading: T;
  core: {
    activity: T;
  };
  settings: {
    members: T;
  };
  support: {
    supportAdmin: T;
    supportTech: T;
  };
}

export const DefaultWorkspaceUserFeatures: WorkspaceUserFeatures = {
  loading: true,
  core: {
    activity: false
  },
  settings: {
    members: false
  },
  support: {
    supportAdmin: false,
    supportTech: false
  }
};

export type ConvertedToObjectType<T> = {
  [P in keyof T]: T[P] extends string ? string : ConvertedToObjectType<T[P]>;
};

const convertObjectToKeys = (obj: any, dict: any, current?: string) => {
  Object.keys(obj).forEach((key: string) => {
    const currentLookupKey = current ? `${current}.${key}` : key;
    if (typeof obj[key] === 'object') {
      dict[key] = {};
      convertObjectToKeys(obj[key], dict[key], currentLookupKey);
    } else {
      dict[key] = currentLookupKey;
    }
  });
};

export const feature: ConvertedToObjectType<WorkspaceUserFeatures<string>> =
  {} as any;

convertObjectToKeys(DefaultWorkspaceUserFeatures, feature);
